import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import BarChart from 'components/highcharts/BarChart';
import { PROJECTS } from '../services/projects.services';

const PeopleEffortOverTimeColumn = ({ iterations, isExtendedView = false }) => {
  const barChartData = iterations.reduce(function (map, obj) {
    map[obj.start] = [obj.contributors];
    return map;
  }, {});

  const barChartTooltipLabels = ['', 'Time'];
  const reduceBarWidth = _.size(barChartData) > 15;
  const barChartSize = isExtendedView
    ? PROJECTS.LARGE_CHART_SIZE
    : PROJECTS.SMALL_BAR_SIZE;

  const defaultProps = {
    barColor: 'havelockBlue',
    backgroundColor: 'transparent',
    tooltipLabels: barChartTooltipLabels,
    data: barChartData
  };

  return (
    <Flex style={barChartSize}>
      {isExtendedView ? (
        <BarChart
          margin={PROJECTS.LARGE_CHART_MARGIN}
          showTooltip
          yProps={{
            lineWidth: 0,
            gridLineWidth: 0,
            tickAmount: 'default',
            softMax: 'default',
            style: PROJECTS.CHART_STYLE
          }}
          xProps={{
            lineWidth: 1,
            gridLineWidth: 0
          }}
          {...defaultProps}
        />
      ) : (
        <BarChart
          margin={PROJECTS.SMALL_CHART_MARGIN}
          showTooltip={false}
          tickInterval={0}
          barWidth={reduceBarWidth ? 3 : null}
          smallGraph
          yProps={{
            lineWidth: 0,
            gridLineWidth: 0,
            labelDisabled: true
          }}
          xProps={{
            lineWidth: 0.5,
            gridLineWidth: 0
          }}
          {...defaultProps}
        />
      )}
    </Flex>
  );
};

export default PeopleEffortOverTimeColumn;
